import React from 'react';
import Reflux from 'reflux';
import FormItemConst from '../../formItem/FormItemConst';
import {DiaLogMapEditorsStore} from '../../stores/CommandStore';
import DialogValue from './remote/DialogValue';
import Fade from '../../utils/Fade';
import FormItemDateResolver from '../../formItem/resolver/FormItemDateResolver';

export default class DialogFieldDateEditor extends React.Component
{
	lookupStates = 
	{
		isShowed:false
	}

	constructor(props)
	{
		super(props);
		this.state = {data:this.props.data};
		this.unsubscribeDiaLogMapEditorsStore = DiaLogMapEditorsStore.listen(this.onDiaLogMapEditors.bind(this));
	}

	onDiaLogMapEditors(dialogId,result)
	{
		if(this.props.dialogId == dialogId)
		{
			let dv = new DialogValue();
			dv.id = this.props.data.id;dv.editorType = this.props.data.editorType;
			dv.value = $(this.inputField).val();dv.entityId = this.props.data.entityId;
			//alert("DialogFieldStringEditor侦听");
			result[this.props.data.id] = dv;
		}
	}

	componentDidMount()
	{
		$(this.inputField).datepicker({
		      language: 'zh-CN',
		      autoclose: true,//选中之后自动隐藏日期选择框
		      clearBtn: true,//清除按钮
		      todayBtn: true,//今日按钮
		      format: "yyyy-mm-dd",
		      buttonImageOnly: true,
		      hide:this.onDatePanelClose.bind(this)
		  });
	}

	componentWillUnmount()
	{
		this.unsubscribeDiaLogMapEditorsStore();
	}

	onDatePanelClose()
	{
		this.lookupStates.isShowed = false;
	}

	inputFieldBlur()
	{
		let	value = $(this.inputField).val();
		if(!value)
			return;
		if(value == "t" || value == "T")
		{
			var today = new Date();
			value = today.getFullYear()+"-"+(today.getMonth()+1)+"-"+today.getDate();
		}
		if(value)
		{
			value = FormItemDateResolver.getResult(value,false);
			if(value.indexOf("false:") == 0)
			{
				Fade.show({text:value.substr(6)});
				return false;
			}
		}
		$(this.inputField).val(value);
	}

	onKeyDownHandler(e)
	{
		/*alert(e.keyCode);
		//0-9 t -
		if(
			(e.keyCode>95&&e.keyCode<106) ||
			(e.keyCode == 189) ||
			(e.keyCode == 84)
		)
		{

		}
		else
		{
			e.preventDefault();
		}*/
		if(e.keyCode>64&&e.keyCode<91)
		{
			e.preventDefault();
		}
	}

	getInputDom(_width)
	{
		let allowEdit = this.state.data.allowEdit;
		let _id = this.state.data.id;
		let _defaultValue = this.state.data.defaultValue;
		if(!_defaultValue)
			_defaultValue = "";
		if(allowEdit != false)
		{
			let _style = {padding:'2px',height:FormItemConst.EDITOR_HEIGHT+'px',width:_width,fontSize:"12px"};
			return 	<input spellCheck="false" id={"inputDialog"+_id} ref={ node => this.inputField = node } type="text" 
							className="form-control pull-right" style={_style} defaultValue={_defaultValue}  
							onBlur={this.inputFieldBlur.bind(this)}  onKeyDown={this.onKeyDownHandler.bind(this)}/>;
		}	
		else
		{
			let _style = {padding:'2px',height:FormItemConst.EDITOR_HEIGHT+'px',width:_width,backgroundColor:FormItemConst.EDITOR_NOTEDIT_COLOR,fontSize:"12px"};
			return	 <input spellCheck="false" id={"inputDialog"+_id} ref={ node => this.inputField = node } readOnly="readonly" type="text" 
							className="form-control pull-right" style={_style} defaultValue={_defaultValue}
							onBlur={this.inputFieldBlur.bind(this)}  onKeyDown={this.onKeyDownHandler.bind(this)}/>;
		}
	}

	showDateDropDown()
	{
		var nowAllowEdit = $(this.inputField).attr("readonly")==undefined;
		if(!nowAllowEdit)
			return;
		var $pickerdropdown = $("div.datepicker");
		if ($pickerdropdown.is(':visible'))
		{
			this.lookupStates.isShowed = false;
			$(this.inputField).datepicker('hide');
		}
		else
		{
			this.lookupStates.isShowed = true;
			$(this.inputField).datepicker('show');
		}
	}

	getDownArrowButtonDom()
	{
		let allowEdit = this.state.data.allowEdit;
		if(allowEdit != false)
		{
			return	<i ref={node => this.downArrowButton = node} onMouseDown={this.showDateDropDown.bind(this)} className="fa fa-calendar" style={{position:'absolute',top:'calc(100% / 2 - 5.5px)',left:'calc(100% - 13px)',fontSize:'11px',cursor:'pointer',zIndex:3}}></i>; 
					//<div ref={node => this.downArrowButton = node} className="input-group-addon" style={{cursor:'pointer',paddingTop:'2px',width:'33px',paddingLeft:'6px',paddingRight:'6px',height:'22px',paddingBottom:'2px'}} onMouseDown={this.showDateDropDown.bind(this)}><i className="fa fa-calendar"></i></div>;
		}
		else
		{
			//return <div ref={node => this.downArrowButton = node} className="input-group-addon" style={{cursor:'pointer',paddingTop:'2px',width:'33px',paddingLeft:'6px',paddingRight:'6px',height:'22px',paddingBottom:'2px',backgroundColor:FormItemConst.EDITOR_NOTEDIT_COLOR}} onMouseDown={this.showDateDropDown.bind(this)}><i className="fa fa-calendar"></i></div>;
			return <i ref={node => this.downArrowButton = node} className="fa fa-calendar" style={{position:'absolute',top:'calc(100% / 2 - 5.5px)',left:'calc(100% - 13px)',fontSize:'11px',cursor:'pointer',zIndex:3}}></i>
		}
	}

	render()
	{
		let displayLength=this.state.data.displayLength;
		let _width = 100;
		if(this.state.data.width>0)
		{
			_width = this.state.data.width;
		}
		else
		{
			if(displayLength == 0)displayLength = FormItemConst.DISPLAYLENGTH_DATE_DEFAULT;
			_width=displayLength*FormItemConst.displayLength_EN+FormItemConst.displayLength_ENAddon+'px';
		}
		
		let notNull=this.state.data.notNull;
		let _label = this.state.data.label;
		let _id = this.state.data.id;
		var _notNullStyle={};
		_notNullStyle['fontSize']='8px';
    	_notNullStyle['color']='red';
		if(!notNull)
			_notNullStyle['visibility']='hidden';

		let editorStyle = {display:'flex',flexDirection:'row',alignItems:'center'};
		let inputdom = this.getInputDom(_width);
		let downArrowButtonDom = this.getDownArrowButtonDom();
		return (
			<div id={"EditorDialog"+_id} className='editorGroup' style={editorStyle}>
			  <label htmlFor={"inputDialog"+_id} className="fieldGroupLabel" ref={node => this.componentLabel = node}
			  		 style={{paddingLeft:'5px',width:'auto',textAlign:'right',whiteSpace:'nowrap',marginBottom:'0px'}}>
			  		 {_label}
			  		 
			  </label>
			 	<i className='fa fa-snowflake-o' style={_notNullStyle}></i>
			  <div className="input-group date">
			  	{inputdom}{downArrowButtonDom}
		      </div>
		       
			</div>
		);
	}
}


// WEBPACK FOOTER //
// ./src/components/dialog/DialogFieldDateEditor.js